import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        display: 'flex',
        minWidth: '340px',
        maxWidth: '400px',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'center',
        backgroundColor: theme.palette.common.white,
        borderRadius: '4px',
        padding: '16px',
        border: `1px solid ${theme.palette.grey[200]}`,
    },
    status_container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px 12px',
        borderRadius: '4px',
        backgroundColor: theme.palette.grey[100],
    },
    status_label: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '15px',
        fontWeight: 600,
    },
    status_icon: {
        fontSize: '22px',
    },
    active: {
        color: theme.palette.success.main,
    },
    inactive: {
        color: theme.palette.error.main,
    },
    hint: {
        marginTop: '12px',
        wordBreak: 'break-word',
    },
    actions_container: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        marginTop: '8px'
    },
    cancel_btn: {
        marginTop: '16px',
        marginRight: '10px'
    },
    input: {
        marginTop: '16px'
    }
}));

export {useStyles}
